import React from 'react'

const sideCol = () => {
  return (
    <div>
      <div className='left_social'>
        <a href="https://wa.me/918885656752" target='_blank' rel="noreferrer" className='text-bold text-green-500'>
          <img src="https://trinoxabrasives.com/static/images/whatsapp-icon-logo-svgrepo-com.svg" alt="" loading="lazy" />
          <span>Whatsapp</span>
        </a>
        <a href="https://www.instagram.com/abron_trinoxabrasives?igsh=NHVyZGJhaGx4ZXF4&utm_source=qr" target='_blank' rel="noreferrer" className='text-bold text-purple-500'>
          <img src="https://trinoxabrasives.com/static/images/instagram-1-svgrepo-com.svg" alt="" loading="lazy" />
          <span>Instagram</span>
        </a>
      </div>
    </div>
  )
}

export default sideCol